const copyViaTextArea = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (error) {
    console.error('Unable to copy to clipboard', error)
  }

  document.body.removeChild(textArea)
}

export const copyTextToClipboard = (text: string) => {
  if (window.isSecureContext && navigator.clipboard) {
    void navigator.clipboard.writeText(text)
    return
  }

  copyViaTextArea(text)
}
